import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import image from "./logo.png";
import "./MainNavbar.css";

export default function MainNavbar({ t, lang, setLang }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 40);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => setMenuOpen(false), [location.pathname]);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const closeOnEscape = (event) => { if (event.key === "Escape") setMenuOpen(false); };
    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [menuOpen]);

  const navItems = [
    { to: "/", label: t("welcome"), end: true },
    { to: "/services", label: t("Services") },
    { to: "/about", label: t("about") },
    { to: "/contact", label: t("contact") },
  ];
  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      <nav className={`site-nav fixed-top ${isScrolled ? "site-nav--scrolled" : ""}`} aria-label={t("quickLinks")}>
        <div className="container site-nav__inner">
          <Link className="brand-lockup" to="/" aria-label="Italiano988" onClick={closeMenu}>
            <span className="brand-mark"><img src={image} className="logo-img" alt="" /></span>
            <span className="brand-copy"><strong className="brand-title">Italiano988</strong><small>{t("iandex")}</small></span>
          </Link>

          <button className="site-nav__toggle" type="button" aria-expanded={menuOpen} aria-controls="site-navigation"
            aria-label={menuOpen ? t("nav.close") : t("nav.open")} onClick={() => setMenuOpen((open) => !open)}>
            <span /><span /><span />
          </button>

          <div id="site-navigation" className={`site-nav__panel ${menuOpen ? "site-nav__panel--open" : ""}`}>
            <ul className="site-nav__links">
              {navItems.map(({ to, label, end }) => (
                <li key={to}>
                  <NavLink to={to} end={end} onClick={closeMenu}
                    className={({ isActive }) => `site-nav__link ${isActive ? "site-nav__link--active" : ""}`}>
                    {label}
                  </NavLink>
                </li>
              ))}
            </ul>
            <div className="site-nav__actions">
              <Link to="/services" onClick={closeMenu} className="site-nav__outline">{t("show_services")}</Link>
              <Link to="/contact" onClick={closeMenu} className="site-nav__primary">{t("contact")}</Link>
              <button className="site-nav__language" type="button" onClick={() => { setLang(lang === "en" ? "ar" : "en"); closeMenu(); }}
                aria-label={t("nav.language")}>
                <i className="bi bi-translate" aria-hidden="true" /> {lang === "en" ? "العربية" : "English"}
              </button>
            </div>
          </div>
        </div>
      </nav>
      {menuOpen && <button className="site-nav__backdrop" type="button" aria-label={t("nav.close")} onClick={closeMenu} />}
    </>
  );
}
